module.exports = __webpack_public_path__ + "images/illustrations/illustration-powerpoint@2x-ba81790893a0fff1c8ef8b4c8728c606.webp";